// @ts-nocheck

import { AnimationsActionTypes } from '../types/actions/animations';

export const pushOddsTravelAnimation = ({ oddId, sourceElementUuid, emoji, ts }) => ({
  type: AnimationsActionTypes.ODDS_TRAVEL_PUSH,
  payload: {
    oddId,
    sourceElementUuid,
    emoji,
    ts,
  },
});

export const popOddsTravelAnimation = ({ oddId, sourceElementUuid, ts }) => ({
  type: AnimationsActionTypes.ODDS_TRAVEL_POP,
  payload: {
    oddId,
    sourceElementUuid,
    ts,
  },
});

export const toggleOddsTravelOption = () => ({
  type: AnimationsActionTypes.TOGGLE_ODDS_TRAVEL_OPTION,
});
